import { FMAppRoot, FMSnackbarPlaceholder, FMSnackbars, fmTheme } from "@fokused-me/web-ui";
import { ThemeProvider } from "@material-ui/core";
import { AgreementPage } from "./page/AgreementPage";
import { LanguagePage } from "./page/LanguagePage";
import { LoadingPage } from "./page/LoadingPage";
import { MainPage } from "./page/main/MainPage";
import { ManageNotepadPage } from "./page/ManageNotepadPage";
import { SetPasswordPage } from "./page/SetPasswordPage";
import { UnlockPage } from "./page/UnlockPage";
import { useSession } from "./state/Session";

export const App = () => {
   const { session, isSessionActive } = useSession();

   if (session) {
      let activePage = <LoadingPage />;

      if (!session.languageSelected) {
         activePage = <LanguagePage />;
      } else if (!session.policyAccepted) {
         activePage = <AgreementPage />;
      } else if (!session.verification) {
         activePage = <SetPasswordPage />;
      } else if (!session.appAccessKey || !isSessionActive()) {
         activePage = <UnlockPage />;
      } else if (!session.notepads) {
         activePage = <ManageNotepadPage initMode={true} />;
      } else {
         activePage = <MainPage />;
      }

      // only render FMAppRoot when have settings loaded
      return (
         <ThemeProvider theme={fmTheme}>
            <FMSnackbars.Provider>
               <FMAppRoot language={session && session.language}>{activePage}</FMAppRoot>
               <FMSnackbarPlaceholder />
            </FMSnackbars.Provider>
         </ThemeProvider>
      );
   } else {
      return <LoadingPage />;
   }
};
